import { getFormatRoles } from "../../utils/formatData";
import { Search } from "../../models/home/Search.model";
import { Isearch } from "../../schemas/Search/Search.schema";
import { Anywhere, DryVan } from '../../utils/constants';
import { stateItems } from '../../pages/Manage/ManageCapacity/ManagaCapacityUtil';
import { current_device_date_to_iso_format } from '../../utils/common';
import { dayjs } from "../../utils/Date/DateUtil";
import { IUserDetails } from "../../schemas/user";


const currentDate = new Date().toISOString();

export const getSearchInputes = (
  searchdata: Isearch,
  userDetails: IUserDetails,
  page = 0,
  sortColumn = "pickUpStartDate",
  sortDirection = "asc"
): Search => {
  const model: Search = new Search();
  if (searchdata) {
    const userRole = getFormatRoles();
    model.originCity = searchdata.origin || searchdata.originCity;
    model.originState =
      getOriginStateDetails(searchdata);
    model.originCountry = searchdata.originCountry;
    model.originPostalCode = getOriginRadius(searchdata);    
    model.originRadius = searchdata.originRadius;
    model.pickUpStartDate = getPickUpStartDate(searchdata);
    model.pickUpEndDate = getPickUpEndDate(searchdata);
    model.dropStartDate = getDropStartDate(searchdata);
    model.dropEndDate = getDropEndDate(searchdata);
    model.destinationCity = getDestinationData(searchdata);
    model.destinationStates = searchdata.destinationStates;
    model.destinationCountry = searchdata.destinationCountry;
    model.destinationPostalCode = searchdata.destination === "Anywhere" ? '' : searchdata.destinationPostalCode;
    model.destinationRadius = searchdata.destinationRadius;
    model.favorite = searchdata.favorite;
    model.trailerType = getSearchTrailerType(searchdata);
    model.userId = getUserDetailsUserID(userDetails);
    model.carrierId = (userDetails?.memberDetailsResponse?.member?.carrierId) || null;
    model.page = page;
    model.size = 5;
    model.sortColumn = sortColumn;
    model.sortDirection = sortDirection;
    model.carrierScac = (userDetails?.memberDetailsResponse?.carrierInfo?.carrierScac) || "";
    model.carrierTier = (userDetails?.memberDetailsResponse?.carrierInfo?.carrierTier) || "";
    model.managedEquipmentCapability = (userDetails?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability) || "";
    model.nonManagedEquipmentCapability = (userDetails?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability) || "";
    model.userRole = userRole.join(",");
  }
  return model;
};
export const getSegmentData = (searchParams: any) => {
  const segmentParams: any = [];
  searchParams.origin && (segmentParams["origin"] = searchParams.origin + `${searchParamsOrginStateValue(searchParams)}`);
  searchParams.originRadius && (segmentParams["Origin Radius"] = searchParams.originRadius);

  if (searchParams.origin !== "Anywhere") {
    let date = getDateRange(searchParams.pickUpStartDate, searchParams.pickUpEndDate);
    date && (segmentParams["Pick up date"] = date);
  }
  if (searchParams.destination) {
    segmentParams["destination"] =
      searchParams.destination + `${searchParams.destinationStates && searchParams.destinationStates.length === 1 ? ", " + searchParams.destinationStates[0] : ''}`;
  } else if (
    searchParamsDestinationCheck(searchParams)
  ) {
    segmentParams["destinationStates"] = searchParams.destinationStates.join(",");
  }
  if (searchParams.destination !== "Anywhere") {
    let date = getDateRange(searchParams.dropStartDate, searchParams.dropEndDate);
    date && (segmentParams["Drop date"] = date);
  }
  searchParams.TrailerType && (segmentParams["Trailer type"] = searchParams.TrailerType);
  searchParams.favorite && (segmentParams["favorite"] = searchParams.favorite);
  return segmentParams;
};

export const getDateRange = (from: string, to: string) => {
  let fromDate = (from && from.split("T")[0]) || null;
  fromDate = fromDate ? dayjs(fromDate).format("MMM DD") : "";
  let toDate = (to && to.split("T")[0]) || null;
  toDate = toDate ? dayjs(toDate).format("MMM DD") : "";
  if (fromDate && toDate) {
    return fromDate + " - " + toDate;
  } else if (fromDate) {
    return fromDate;
  } else if (toDate) {
    return toDate;
  }
};

export const getDestinationStateValue = (detail: any) => {
  let states = [];
  if (detail.destinationState) states.push(detail.destinationState.trim());
  if (detail.destinationState1) states.push(detail.destinationState1.trim());
  if (detail.destinationState2) states.push(detail.destinationState2.trim());
  if (detail.destinationState3) states.push(detail.destinationState3.trim());
  return states;
}

export const getFormValues = (originfeilds: boolean, destinationfeilds: boolean, savedData: any = {}, originTimePeriod: number, dstTimePeriod: number, isRecent: boolean, currentLocation: any, isResetClicked: boolean) => {
  let formFeilds: any = {};
  let pickUpEndDate = '';
  let dropEndDate = '';
  const toDate = new Date(currentDate);
  toDate.setDate(toDate.getDate() + originTimePeriod);
  pickUpEndDate = dayjs(toDate).format("YYYY-MM-DD");
  const dropToDate = new Date(currentDate);
  dropToDate.setDate(dropToDate.getDate() + dstTimePeriod);
  dropEndDate = dayjs(dropToDate).format("YYYY-MM-DD");
  const isSavedData = !!Object.keys(savedData).length;
  if (originfeilds) {
    formFeilds = {
      TrailerType: getTrailerTypeValue(isSavedData, isResetClicked, isRecent, savedData),
      origin: getOriginFieldsOrigin(isSavedData, isResetClicked, isRecent, savedData, currentLocation),
      originCountry: getOriginCountry(isSavedData, isResetClicked, isRecent, savedData, currentLocation),
      originRadius: getOriginRadiusData(isSavedData, isResetClicked, isRecent, savedData),
      originState: getOriginState(isSavedData, isResetClicked, isRecent, savedData, currentLocation),
      originPostalCode: getOriginPostalCode(isSavedData, isResetClicked, isRecent, savedData, currentLocation),      
      pickUpStartDate: getPickUpStartDateData(isRecent, isResetClicked, isSavedData, savedData),
      pickUpEndDate: getPickUpEndDateData(isRecent, isResetClicked, isSavedData, pickUpEndDate, savedData),
      rangeOriginDisable: rangerOriginDisableData(isSavedData, isResetClicked, isRecent, savedData, currentLocation),
      pickUpdateError: false,
      originError: "",
      isPickUpTimeError: false,
      isCityError: false,
    }
  }
  if (destinationfeilds) {
    const destinationStatesLength = isDestinationStatesLength(isSavedData, savedData);
    formFeilds = {
      ...formFeilds,
      destination: getDestinationDetails(isSavedData, isResetClicked, isRecent, savedData, destinationStatesLength),
      destinationCountry: getDestinationCountryDetails(isSavedData, isResetClicked, isRecent, savedData),
      destinationRadius: getDestinationStatesDetails(isSavedData, isResetClicked, isRecent, savedData),
      destinationStates: getDestinationStates(isSavedData, isResetClicked, isRecent, savedData),
      destinationPostalCode: getDestinationPostalCode(isSavedData, isResetClicked, isRecent, savedData),            
      dropStartDate: getDropStartDateDetails(isRecent, isResetClicked, isSavedData, savedData),
      dropEndDate: getDropEndDateDetails(isRecent, isResetClicked, isSavedData, dropEndDate, savedData),
      rangeDisable: getRangDisableDetails(isSavedData, isResetClicked, isRecent, savedData),
      favorite: getFavoriteDetailsData(isSavedData, isResetClicked, isRecent, savedData),
      country: getDestinationCountryDetails(isSavedData, isResetClicked, isRecent, savedData),
      statesList: getStateListDetails(destinationStatesLength, isResetClicked, isRecent, savedData),
      stateError: false,
      dropUpdateError: false,
      destinationError: "",
      isDropTimeError: false,
      isCityError: false,
    }
  }
  return formFeilds;
}
const getValues = (destinationStates: any) => {
  const list = stateItems.map((state: any, index: number) => ({
    ...state,
    value: destinationStates[index],
  }));
  return list;
}

const getOriginStateDetails=(searchdata: Isearch): string | undefined =>{
  return searchdata.origin === "Anywhere" ? "Anywhere" : searchdata.originState && searchdata.originState.trim();
}

const getDestinationData=(searchdata: Isearch): string | undefined =>{
  return searchdata.destination || searchdata.destinationCity || '';
}

const getDropEndDate = (searchdata: Isearch): string | undefined =>{
  return searchdata.destination === "Anywhere" ? '' : searchdata.dropEndDate;
}

const getDropStartDate = (searchdata: Isearch): string | undefined => {
  return searchdata.destination === "Anywhere" ? '' : searchdata.dropStartDate;
}

const getPickUpEndDate=(searchdata: Isearch): string | undefined=> {
  return searchdata.origin === "Anywhere" ? '' : searchdata.pickUpEndDate;
}

const getPickUpStartDate=(searchdata: Isearch): string | undefined =>{
  return searchdata.origin === "Anywhere" ? '' : searchdata.pickUpStartDate;
}

const getOriginRadius =(searchdata: Isearch): string | undefined=> {
  return searchdata.origin === "Anywhere" ? '' : searchdata.originPostalCode;
}
const searchParamsOrginStateValue=(searchParams: any)=> {
  return searchParams.originState !== "Anywhere" && searchParams.originState ? "," + searchParams.originState : '';
}

const searchParamsDestinationCheck=(searchParams: any) =>{
  return !searchParams.destination &&
    searchParams.destinationStates &&
    searchParams.destinationStates.length > 0;
}

const getTrailerTypeValue=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.TrailerType : DryVan;
}

const getOriginFieldsOrigin=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any, currentLocation: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.origin + `${savedData.originState !== "Anywhere" && savedData.originState ? ", " + savedData.originState : ''}` : currentLocation.cityName || Anywhere;
}

const rangerOriginDisableData = (isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any, currentLocation: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.origin === Anywhere || savedData.origin === null : currentLocation.cityName === '';
}

const getPickUpEndDateData =(isRecent: boolean, isResetClicked: boolean, isSavedData: boolean, pickUpEndDate: string, savedData: any) => {
  return isRecent || isResetClicked || !isSavedData ? pickUpEndDate : savedData.pickUpEndDate;
}

const getPickUpStartDateData =(isRecent: boolean, isResetClicked: boolean, isSavedData: boolean, savedData: any) =>{
  return isRecent || isResetClicked || !isSavedData ? current_device_date_to_iso_format() : savedData.pickUpStartDate;
}

const getOriginPostalCode = (isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any, currentLocation: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.originPostalCode : currentLocation.postalCode || "";
}

const getOriginState =(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any, currentLocation: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.originState : currentLocation.cityName ? currentLocation.cityName.split(", ")[1] : "";
}

const getOriginRadiusData =(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.originRadius : 100;
}

const getOriginCountry =(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any, currentLocation: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.originCountry : currentLocation.country || "";
}

const getStateListDetails=(destinationStatesLength: any, isResetClicked: boolean, isRecent: boolean, savedData: any) =>{
  return destinationStatesLength && !(isResetClicked && !isRecent) ? getValues(savedData.destinationStates) : stateItems;
}

const getFavoriteDetailsData=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.favorite : false;
}

const getRangDisableDetails=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.destination === Anywhere || savedData.destination === null : true;
}

const getDropEndDateDetails=(isRecent: boolean, isResetClicked: boolean, isSavedData: boolean, dropEndDate: string, savedData: any)=> {
  return isRecent || isResetClicked || !isSavedData ? dropEndDate : savedData.dropEndDate;
}

const getDropStartDateDetails=(isRecent: boolean, isResetClicked: boolean, isSavedData: boolean, savedData: any) =>{
  return isRecent || isResetClicked || !isSavedData ? current_device_date_to_iso_format() : savedData.dropStartDate;
}

const getDestinationPostalCode=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.destinationPostalCode : "";
}

const getDestinationStates=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.destinationStates : [];
}

const getDestinationStatesDetails=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.destinationRadius : 100;
}

const getDestinationCountryDetails=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any)=> {
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.destinationCountry === "US" ? "USA" : savedData.destinationCountry : 'USA';
}

const getDestinationDetails=(isSavedData: boolean, isResetClicked: boolean, isRecent: boolean, savedData: any, destinationStatesLength: any) =>{
  return isSavedData && !(isResetClicked && !isRecent) ? savedData.destination && savedData.destination + `${destinationStatesLength === 1 ? ', ' + savedData.destinationStates[0] : ''}` || Anywhere : Anywhere;
}

const isDestinationStatesLength=(isSavedData: boolean, savedData: any)=> {
  return isSavedData && savedData.destinationStates && savedData.destinationStates.length;
}

const getUserDetailsUserID =(userDetails: IUserDetails): string | undefined=> {
  return (userDetails?.memberDetailsResponse?.member?.upn) || "";
}

const getSearchTrailerType=(searchdata: Isearch): string | undefined =>{
  return searchdata.TrailerType || searchdata.trailerType;
}

